import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as form } from 'redux-form';

import account from './account/accountReducer';
import api from './api/apiRootReducer'; // TODO move this module up one level
import { reducer as appConfig } from './appConfig';
import basket from './basket/reducer';
import cart from './cart/reducer';
import { reducer as cartStack } from './cartStack';
import deleteProjectDialog from './deleteProjectDialog/reducer';
import dialogs from './dialogs/reducer';
import errors from './error/errorReducer';
import firewallPresets from './firewallPresets/reducer';
import gtm from './gtm/reducer';
import internalOnly from './internalOnly/reducer';
import maintenanceMode from './maintenanceMode/reducer';
import manageRedirect from './manageRedirect/manageRedirectReducer';
import marketplace from './marketplace/reducer';
import notifications from './notifications/reducer';
import { oidcReducer as oidc } from './oidc/redux';
import payment from './payment/paymentReducer';
import paymentForm from './paymentForm/reducer';
import projectAddDialog from './projectAddDialog/reducer';
import referAFriendDialog from './referAFriendDialog/reducer';
import renameProjectDialog from './renameProjectDialog/reducer';
import renewDialog from './renewDialog/reducer';
import { reducer as route } from './route';
import server from './server/reducer';
import serviceWorker from './serviceWorker/reducer';
import sshkeys from './sshkeys/reducer';
import usertaskOperations from './usertask/reducer';
import { reducer as utility } from './utility';
import www from './www-api/wwwReducer';

const rootReducer = (history) =>
	combineReducers({
		account,
		api,
		appConfig,
		basket,
		cart,
		cartStack,
		deleteProjectDialog,
		dialogs,
		errors,
		firewallPresets,
		form,
		gtm,
		internalOnly,
		maintenanceMode,
		manageRedirect,
		marketplace,
		notifications,
		oidc,
		payment,
		paymentForm,
		projectAddDialog,
		referAFriendDialog,
		renameProjectDialog,
		renewDialog,
		route,
		router: connectRouter(history),
		server,
		serviceWorker,
		sshkeys,
		usertaskOperations,
		utility,
		www,
	});

export default rootReducer;
